import { sharedComponents as sharedComponentsEnUs } from '../en-us/sharedComponents';
import { AgResourceLanguage } from '../types';

export const sharedComponents: AgResourceLanguage['sharedComponents'] = {
  ...sharedComponentsEnUs,
  summaryCheckout: {
    ...sharedComponentsEnUs.summaryCheckout,
    shippingExpectedPrice: 'Free'
  }
};
